import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize, lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CatalogosService } from 'src/app/services/catalogos/catalogos.service';
import { SpinnerService } from 'src/app/services/helpers/spinner.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm = this.fb.group({
    username: [null,Validators.required],
    password: [null,[Validators.required, this.checkPassword]],
    getHash: true
  })


  constructor(
    public fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private spinner: SpinnerService,
    private catalogosService: CatalogosService
  ) { }

  ngOnInit(): void {
  }

  onSubmit() {
    this.spinner.show();
    let loginData = this.loginForm.getRawValue();
    
    if (!this.loginForm.value.username && !this.loginForm.value.password) {
      Swal.fire("Datos erróneos", "Por favor, ingrese la información solicitada", 'warning');
      this.spinner.hide();
      return;
    }

    this.authService.login(loginData)
      .pipe(finalize(() => { this.spinner.hide() }))
      .subscribe(res => {
        console.log(res);
        
        if (res.code == 200) {
          if (res.data?.token) {
            this.authService.setToken(res.data.token);
            loginData.getHash = false;
            this.authService.login(loginData)
              .pipe(finalize(() => { this.spinner.hide() }))
              .subscribe({
                next: (ses) => {
                  this.authService.saveSession(ses.data).subscribe(async createdSession => {
                    if (createdSession) {
                      // retrieve catalogos from database and save on localstorage
                      let catalogos$ = this.catalogosService.getCatalogos();
                      this.catalogosService.setCatalogos(await lastValueFrom(catalogos$))
                      this.router.navigate(['/index']);
                    }
                    else {
                      localStorage.clear();
                      Swal.fire("Ocurrio un error", "No fue posible iniciar sesión, intenta nuevamente", 'warning');
                    }
                  })
                },
                error: (err) => {
                  console.log(err);
                  this.spinner.hide()
                }
              })
          }
          else {
            Swal.fire("Ocurrio un error", "Pongase en contacto con el administrador de TI", 'warning');
          }
        }
        else {
          // this.spinner.hide();
          Swal.fire("Problemas al iniciar sesión", res.message_details, 'warning');
        }
      }, error => this.spinner.hide())

  }
  get ID_PERFIL() {
    return this.authService.getUserSessionData('ID_PERFIL');
  }
  checkPassword(control) {
    let enteredPassword = control.value
    let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
    return (!passwordCheck.test(enteredPassword) && enteredPassword) ? { 'requirements': true } : null;
  }
}
